import bindAllOfThis from "src/utils/BindThisHelper";
import { PhaserButtonConfig, PhaserButton } from "src/games/shared/Button";
import TranslateApi from "src/utils/TranslateHelper";
import { Color } from "src/games/shared/ColorValue";
import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import AudioTranslations from "src/constants/AudioTranslations";

export class EndGameScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    private skyColor: number = 0x6eb8e5;

    hollandCode: "r" | "i" | "a" | "s" | "e" | "c" = "s";

    gameClosingTextKey: string = "FindHelpers.Phaser.GameClosing";
    buttonTextKey: string = "student.postgame.button";

    constructor() {
        super({
            key: "EndGameScene"
        });
    }

    preload(): void {
        this.load.tilemapTiledJSON('outro-map', require("/src/assets/qci/maps/outro_scene.json"));
        this.load.audio(
            this.gameClosingTextKey,
            AudioTranslations.FindByKeyAndLanguage(this.gameClosingTextKey, TranslateApi.currentLanguage.code).url
        );
    }

    create(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        bindAllOfThis(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });

        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();

        let sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!

        this.map.getObjectLayer("Objects").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "text") {
                this.addDialogBoxWithButton(ob, this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                let terrain = this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    }

    addDialogBoxWithButton(ob: TiledGameObject, translateKey: string): void {
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = Color.PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = Color.KUDER_PRIMARY_BUTTON;

        // Add all the paragraphs to one big textbox
        var translatedText = TranslateApi.translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach((para: string) => {
            var paragraph = this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });


        var config: PhaserButtonConfig = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };

        // Button to start your game
        var buttonText = TranslateApi.translate(this.buttonTextKey);
        var button = new PhaserButton(this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);

        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', () => {
            this.sound.stopAll();
            // Game Over
            (this.sys.game as any).onComplete();
        });

        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);

        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);

        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    }
}



// WEBPACK FOOTER //
// ./src/games/FindHelpersGame/scenes/EndGameScene.ts